import * as React from "react";
import { DashboardContainer } from "../../../libs/commission_calculator_dashboard";
import DashboardPercentileSection from "./DashboardPercentileSection";
import { DashboardBarRankSection } from "./DashboardBarRankSection";

interface IProps {
  salespeople?: any;
  commissionsAll?: any;
}

const DashboardRankingManager = ({ salespeople, commissionsAll }: IProps) => {
  return (
    <DashboardContainer>
      <DashboardPercentileSection commissionsAll={commissionsAll} />
      <DashboardBarRankSection commissionsAll={commissionsAll} />
    </DashboardContainer>
  );
};

export default DashboardRankingManager;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/dashboard/DashboardRankingManager.tsx